/** The welcome's steps (kept apart so the shell can read them without loading the welcome itself). */
export type WelcomeStep = 'you' | 'profile' | 'prefs' | 'start';

export const WELCOME_STEPS: { id: WelcomeStep; label: string }[] = [
  { id: 'you', label: 'You' },
  { id: 'profile', label: 'Photo and mobile' },
  { id: 'prefs', label: 'Preferences' },
  { id: 'start', label: 'Start' },
];
